export const launcherErrorCodes = {
  ConnectionError: 1011,
  Reconnect: 1012,
  GameIsOpen: 1013,
};
